import Grid from '@mui/material/Grid'
import { useDigitalTwinHeatSuppliers } from 'api/heatSuppliers/heatSuppliers.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'ui/atoms'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import SystemMessageBanner from 'ui/components/SystemMessageBanner/SystemMessageBanner'
import View from 'ui/components/View/View'
import Overview from 'views/SamEnergiView/components/Overview/Overview'
import SamEnergiHeader from 'views/SamEnergiView/components/SamEnergiHeader/SamEnergiHeader'
import DigitalTwinHeatSuppliers from './components/DigitalTwinHeatSuppliers'

const widgetConstants = {
  SAMENERGI_GRID: `samEnergiGrid`,
  OVERVIEW_WIDGET: `overview_widget`,
  SUPPLIER_WIDGET: `supplier_widget`,
}

function DigitalTwinSamEnergiView(): ReactElement {
  const { t } = useTranslation()

  const { data: heatSuppliers } = useDigitalTwinHeatSuppliers()
  const atleastOneSupplierIsReal = (heatSuppliers ?? []).some((supplier) => !supplier.is_fictive)

  return (
    <View
      header={
        <ModuleHeader infoHeader={t(`SamEnergi`)}>
          {atleastOneSupplierIsReal && (
            <Grid container justifyContent="flex-end">
              <SamEnergiHeader />
            </Grid>
          )}
        </ModuleHeader>
      }
    >
      <SystemMessageBanner module="samenergi" />
      <Grid size={{ xs: 12 }}>
        <Card tourId={widgetConstants.OVERVIEW_WIDGET} title={t(`Overview`)}>
          <Overview />
        </Card>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Card tourId={widgetConstants.SUPPLIER_WIDGET} title={t(`Detailed supplier view`)}>
          <DigitalTwinHeatSuppliers />
        </Card>
      </Grid>
    </View>
  )
}

export default DigitalTwinSamEnergiView
